import { Spinner } from "@msuite/ui/spinner";
import { motion } from "motion/react";

export function InsightsSpotlightThinking() {
	/** Render */
	return (
		<motion.div className="card w-2/3 self-start rounded-xl px-5 py-4 text-lg bg-primary-800 **:text-white! border-primary-900">
			<div className="h-stack">
				<Spinner />
				<p>Thinking...</p>
			</div>
		</motion.div>
	);
}
